import { CloudUpload as UploadIcon } from '@mui/icons-material';
import { Box, CircularProgress, Typography } from '@mui/material';
import React from 'react';
import AssetImage from '../../AssetImage';

/**
 * Visual state of one carousel slide image: spinner, the photo with a
 * replace overlay, or the empty drop hint. Interaction (click/drag/paste)
 * lives on ImageCarouselSlideImageZone around this.
 */
export default function ImageCarouselSlideImagePreview({
  uploading,
  imageUrl,
  altText,
}: {
  uploading: boolean;
  imageUrl?: string;
  altText?: string;
}) {
  if (uploading) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
        <CircularProgress size={24} />
        <Typography variant="caption">Uploading…</Typography>
      </Box>
    );
  }
  if (imageUrl) {
    return (
      <>
        <AssetImage
          url={imageUrl}
          alt={altText || 'slide'}
          sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
        <Box
          className="img-overlay"
          sx={{
            position: 'absolute',
            inset: 0,
            bgcolor: 'rgba(0,0,0,0.45)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            opacity: 0,
            transition: 'opacity 0.2s',
          }}
        >
          <Box sx={{ textAlign: 'center', color: 'white' }}>
            <UploadIcon sx={{ fontSize: 28, mb: 0.5 }} />
            <Typography variant="caption" display="block">
              Click, drag, or paste to replace
            </Typography>
          </Box>
        </Box>
      </>
    );
  }
  return (
    <Box sx={{ textAlign: 'center', color: 'text.secondary', p: 2 }}>
      <UploadIcon sx={{ fontSize: 36, mb: 0.5, opacity: 0.4 }} />
      <Typography variant="caption" display="block">
        Click, drag, or paste image here
      </Typography>
    </Box>
  );
}
